"use strict";

var _regeneratorRuntime = require("/app/front/node_modules/@babel/runtime/regenerator/index.js");

var _slicedToArray = require("/app/front/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _classCallCheck = require("/app/front/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/app/front/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/app/front/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/app/front/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/app/front/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnchorUser = void 0;

var universal_authenticator_library_1 = require("universal-authenticator-library");

var eosio_1 = require("@greymass/eosio");

var UALAnchorError_1 = require("./UALAnchorError");

var AnchorUser = /*#__PURE__*/function (_universal_authentica) {
  _inherits(AnchorUser, _universal_authentica);

  var _super = _createSuper(AnchorUser);

  function AnchorUser(rpc, client, identity) {
    var _this;

    _classCallCheck(this, AnchorUser);

    _this = _super.call(this);
    _this.accountName = '';
    _this.requestPermission = '';
    var session = identity.session;
    _this.accountName = String(session.auth.actor);
    _this.chainId = String(session.chainId);

    if (identity.signatures) {
      var _identity$signatures = _slicedToArray(identity.signatures, 1);

      _this.signerProof = _identity$signatures[0];
    }

    if (identity.signerKey) {
      _this.signerKey = identity.signerKey;
    }

    if (identity.resolvedTransaction) {
      _this.signerRequest = identity.transaction;
    }

    _this.requestPermission = String(session.auth.permission);
    _this.session = session;
    _this.client = client;
    _this.rpc = rpc;
    return _this;
  }

  _createClass(AnchorUser, [{
    key: "objectify",
    value: function objectify(data) {
      return JSON.parse(JSON.stringify(data));
    }
  }, {
    key: "signTransaction",
    value: function signTransaction(transaction, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var completedTransaction, info, tx, wasBroadcast, serializedTransaction, message, type, cause;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!(options.expireSeconds && !transaction.expiration)) {
                  _context.next = 11;
                  break;
                }

                _context.next = 4;
                return this.client.v1.chain.get_info();

              case 4:
                info = _context.sent;
                tx = Object.assign(Object.assign({}, transaction), info.getTransactionHeader(options.expireSeconds));
                _context.next = 8;
                return this.session.transact(tx, options);

              case 8:
                completedTransaction = _context.sent;
                _context.next = 14;
                break;

              case 11:
                _context.next = 13;
                return this.session.transact(transaction, options);

              case 13:
                completedTransaction = _context.sent;

              case 14:
                wasBroadcast = options.broadcast !== false;
                serializedTransaction = eosio_1.PackedTransaction.fromSigned(eosio_1.SignedTransaction.from(completedTransaction.transaction));
                return _context.abrupt("return", this.returnEosjsTransaction(wasBroadcast, Object.assign(Object.assign({}, completedTransaction), {
                  transaction_id: completedTransaction.payload.tx,
                  serializedTransaction: serializedTransaction.packed_trx.array,
                  signatures: this.objectify(completedTransaction.signatures)
                })));

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](0);
                message = 'Unable to sign transaction';
                type = universal_authenticator_library_1.UALErrorType.Signing;
                cause = _context.t0;
                throw new UALAnchorError_1.UALAnchorError(message, type, cause);

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 19]]);
      }));
    }
  }, {
    key: "signArbitrary",
    value: function signArbitrary(publicKey, data, _) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                throw new UALAnchorError_1.UALAnchorError("Anchor does not currently support signArbitrary(".concat(publicKey, ", ").concat(data, ")"), universal_authenticator_library_1.UALErrorType.Unsupported, null);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }, {
    key: "verifyKeyOwnership",
    value: function verifyKeyOwnership(challenge) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                throw new UALAnchorError_1.UALAnchorError("Anchor does not currently support verifyKeyOwnership(".concat(challenge, ")"), universal_authenticator_library_1.UALErrorType.Unsupported, null);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    }
  }, {
    key: "getAccountName",
    value: function getAccountName() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.accountName);

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "getChainId",
    value: function getChainId() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.chainId);

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "getKeys",
    value: function getKeys() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var keys, message, type, cause;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return this.signatureProvider.getAvailableKeys(this.requestPermission);

              case 3:
                keys = _context6.sent;
                return _context6.abrupt("return", keys);

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](0);
                message = "Unable to getKeys for account ".concat(this.accountName, ".\n        Please make sure your wallet is running.");
                type = universal_authenticator_library_1.UALErrorType.DataRequest;
                cause = _context6.t0;
                throw new UALAnchorError_1.UALAnchorError(message, type, cause);

              case 13:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 7]]);
      }));
    }
  }, {
    key: "isAccountValid",
    value: function isAccountValid() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var account, actualKeys, authorizationKeys, message, type, cause;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.t0 = this.client;

                if (!_context7.t0) {
                  _context7.next = 6;
                  break;
                }

                _context7.next = 5;
                return this.client.v1.chain.get_account(this.accountName);

              case 5:
                _context7.t0 = _context7.sent;

              case 6:
                account = _context7.t0;
                actualKeys = this.extractAccountKeys(account);
                _context7.next = 10;
                return this.getKeys();

              case 10:
                authorizationKeys = _context7.sent;
                return _context7.abrupt("return", actualKeys.filter(function (key) {
                  return authorizationKeys.indexOf(key) !== -1;
                }).length > 0);

              case 14:
                _context7.prev = 14;
                _context7.t1 = _context7["catch"](0);

                if (!(_context7.t1.constructor.name === 'UALAnchorError')) {
                  _context7.next = 18;
                  break;
                }

                throw _context7.t1;

              case 18:
                message = "Account validation failed for account ".concat(this.accountName, ".");
                type = universal_authenticator_library_1.UALErrorType.Validation;
                cause = _context7.t1;
                throw new UALAnchorError_1.UALAnchorError(message, type, cause);

              case 22:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 14]]);
      }));
    }
  }, {
    key: "extractAccountKeys",
    value: function extractAccountKeys(account) {
      var keySubsets = account.permissions.map(function (permission) {
        return permission.required_auth.keys.map(function (key) {
          return key.key;
        });
      });
      var keys = [];

      var _iterator = _createForOfIteratorHelper(keySubsets),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var keySubset = _step.value;
          keys = keys.concat(keySubset);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return keys;
    }
  }]);

  return AnchorUser;
}(universal_authenticator_library_1.User);

exports.AnchorUser = AnchorUser;